 <template>
  <div
    class="pagoda-bdc-select"
    :class="{
      'not-multiple': !isMultiple,
      'advanced-search': advancedSearch,
      'clearable': isClearable,
      'remote': !!remote
    }"
  >
    <async-select
      :value="value"
      @input="_handleInput"
      v-bind="$attrs"
      @remove-tag="removeTag"
      v-on="$$listeners"
      :labelKey="labelKey"
      :valueKey="objectValue ? valueKey : null"
      :request="$API"
      :request-key="`${url}_${JSON.stringify(params)}_${queryStr}`"
      :get-options="_getOptions"
      :remote="!!remote"
      :filterable="!!remote || filterable"
      :remote-method="_handleRemote"
      @complete="loading = false"
      @load-cache="_firstRequest = false"
      @visible-change="_handleVisibleChange"
      ref="asyncSelect"
    >
      <template slot-scope="scope">
        <slot v-bind="scope"></slot>
      </template>
    </async-select>
    <span
      class="el-input__suffix el-input__suffix-more"
      v-if="advancedSearch"
      v-show="!loading && !$refs.asyncSelect.loading"
      @click.stop="handleAdvancedSearch"
    >
      <span class="el-input__suffix-inner">
        <i class="el-select__caret el-input__icon el-icon-more"></i>
      </span>
    </span>
    <el-dialog
      v-if="advancedSearch"
      :visible.sync="dialog.visible"
      v-bind="dialogProps"
      append-to-body
    >
      <slot :dialog="dialog" name="advanced-search"></slot>
    </el-dialog>
  </div>
</template>

<script>
  import AsyncSelect from "../async-select"

  import getApiConfig from './api.js'

  import {
    isArray,
    getEmptyObject,
    bounce
  } from "../../../utils"

  export default {
    name: 'BdcSelect',
    inheritAttrs: false,
    props: {
      value: null,
      labelKey: {
        required: true
      },
      valueKey: {
        required: true
      },
      objectValue: Boolean,
      params: {
        type: Object,
        default: getEmptyObject
      },
      url: {
        type: String,
        default: ''
      },
      method: {
        type: String,
        default: 'get'
      },
      remote: {
        type: String,
        default: ''
      },
      filterable: {
        type: Boolean,
        default: false
      },
      dialogProps: {
        type: Object,
        default: function () {
          return {
            title: '高级搜索',
            width: '750px'
          }
        }
      },
      firstRequest: {
        type: Boolean,
        default: true
      },
      firstFocusRequest: {
        type: Boolean,
        default: false
      }
    },
    data () {
      this._firstRequest = true
      this._firstFocusRequest = true

      this.$$listeners = {}
      for(const [name, handler] of Object.entries(this.$listeners)) {
        if(name !== 'input' && name !== 'before-input' && name !== 'beforeInput'){
          this.$$listeners[name] = handler
        }
      }

      this.$API = () => {
        const createApi = getApiConfig({
          method: this.method,
          url: this.url
        })

        if (!this.firstRequest && this._firstRequest) {
          this._firstRequest = false

          return Promise.resolve({data: []})
        } else {
          if (this.remote) {
            return createApi({
              ...this.params,
              [this.remote]: this.queryStr
            })
          } else {
            return createApi(this.params)
          }
        }
      }

      return {
        loading: true,
        dialog: {
          visible: false
        },
        queryStr: ''
      }
    },
    watch: {
      value () {

      }
    },
    computed: {
      advancedSearch () {
        return !!this.$scopedSlots['advanced-search']
      },
      isMultiple () {
        return 'multiple' in this.$attrs && this.$attrs.multiple !== false
      },
      isClearable () {
        return 'clearable' in this.$attrs && this.$attrs.clearable !== false
      },
      isDisabled () {
        return 'disabled' in this.$attrs && this.$attrs.disabled !== false
      }
    },
    methods: {
      handleAdvancedSearch () {
        if (!this.isDisabled) this.dialog.visible = true
      },
      _handleVisibleChange (visible) {
        if (visible) {
          const force = this.firstFocusRequest && this._firstFocusRequest

          this.queryStr = ''

          // 实现首次展开列表时懒加载
          if (force) {
            this.$refs.asyncSelect.refresh(true)
              .then(() => {
                this._firstFocusRequest = false
                this.$nextTick(this.$refs.asyncSelect.$refs.elSelect.setSoftFocus)
              })
          }
        }
      },
      _handleRemote: bounce(function (queryStr) {
        this.queryStr = queryStr
        // this.$refs.asyncSelect.refresh(true)
      }, 200),
      _getOptions (res) {
        if(isArray(res.data)) {
          this.res = res.data
        }else {
          this.res = res.data.content
        }

        this.dataMap = {}
        this.indexMap = {}

        const options =  this.res.map((item, idx) => {
          const key = item[this.valueKey]
          const value = item[this.labelKey]

          this.dataMap[key] = value
          this.indexMap[key] = idx

          if (this.objectValue) {
            return {
              label: value,
              value: item
            }
          } else {
            return {
              ...item,
              label: value,
              value: key,
            }
          }
        })

        this.$emit('data-map-loaded', this.dataMap, this.$attrs.prop)
        this.$emit('data-loaded', res)
        return options
      },
      _handleInput (newVal, selectedData) {
        if(!selectedData) {
          if(isArray(newVal)){
            selectedData = newVal.map(value => this.res[this.indexMap[value]])
          }else{
            selectedData = this.res[this.indexMap[newVal]]
          }
        }

        const input = () => this.$emit('input', newVal, selectedData)

        // 如果有监听before-input事件 则做拦截等待resolve
        if (this._events['before-input'] || this._events['beforeInput']) {
          this.$emit('before-input', input, newVal, selectedData)
          this.$emit('beforeInput', input, newVal, selectedData)
        } else {
          input()
        }
      },
      focus () {
        this.$refs.asyncSelect.focus()
      },
      // 2018-6-28 12:31:31 多选时清空按钮默认清空全部
      removeTag () {
        for (let key of ['collapse-tags', 'collapseTags']) {
          if (key in this.$attrs && this.$attrs[key] !== false) { // 确保是collapseTags才清空全部
            this.$emit('input', [])
            break
          }
        }
      }
    },
    components: {
      AsyncSelect
    }
  }
</script>
